import React, { useContext, useEffect, useState } from 'react';
import GlobalContext from '../../../contexts/GlobalContext';
//import { Link } from "react-router-dom";
import Gmap from '../../Maps/Gmap';
import { Icon, Card, Image, Button, Grid } from 'semantic-ui-react';
import Utility from '../../../Utility';
import './EstablishmentCard.css';

/**
 * Components Establishment
 * Widget pour le dashboard
 * @param {any} props.etab
 */
const Establishment = props => {
  const [globalContext] = useContext(GlobalContext);
  //const siteMap = Utility.getSiteMap(globalContext.translations);
  const [etabState, setEtabState] = useState(props.etab);
  const [showMapState, setShowMapState] = useState(false);

  //const idEtab = Utility.getSiteMap(globalContext.translations);

  useEffect(() => {
      setEtabState( props.etab );
  }, [props.etab?.id, props.etab?.display])

  const toggleShowMap = () => {
    if (showMapState) {
      setShowMapState(false);
    }
    else{
      setShowMapState(true);
    }
  }

  /**
   * LIEN BE
   */
  let langBe = localStorage.getItem('lang');
  let linkBe = ``;
  let bookingEngineLinkProps = {};
  /*if( etabState?.customLinkBe != '' && typeof etabState?.customLinkBe !== "undefined" ){
    linkBe = `${etabState?.customLinkBe}`;
  }*/
  // eslint-disable-next-line
  if( etabState?.customLinkBeActif && etabState?.customLinkBe != "" ){
    linkBe = `${etabState?.customLinkBe}`;
  }
  else{
    linkBe = Utility.getBookingEngineUrl(etabState?.bookingEngineId, langBe);
    bookingEngineLinkProps = Utility.getBookingEngineLinkProps(etabState?.bookingEngineId, linkBe);
  }

  /**
   * RETOUR HTML
   */
  return (
    <>
    
      <Card
        className='establishment'
        centered
      >
        <Card.Header style={{height:'150px'}}>
          { showMapState ?
            <Gmap lat={parseFloat(etabState?.latitude)} lng={parseFloat(etabState?.longitude)} zoom={13} establishment={etabState}/>
          : <Image 
              className="imageCard"
              /*src={etabState?.logo ?? ""} */
              src={etabState?.establishmentMainPhoto ?? ""} 
              ui={true}
            /> 
          }
          
        </Card.Header>
        <Card.Content>
          {/* Nom Etab */}
          <Card.Header textAlign="center">{etabState?.name}</Card.Header>
          <Card.Description textAlign="center">
            <Grid >
              <Grid.Row columns={1}>
                <Grid.Column>
                  {/* Adresse */}
                  {etabState?.firstAddress ? etabState?.firstAddress + "," : ""}
                  <br></br>
                  {etabState?.zipCode ? etabState?.zipCode : ""} {etabState?.city ? etabState?.city : ""}
                </Grid.Column>
              </Grid.Row>
            
              {/* Mailto et CallTo */}
              <Button.Group fluid>
                <Button icon
                  className="mt-2"
                  onClick={() => toggleShowMap()}
                  >
                  <Icon name='map marker alternate' />
                </Button>
                <Button icon
                  as="a" target="_blank" href={`tel:${etabState?.telephone}`}
                  className="mt-2"
                  >
                  <Icon name='phone' />
                </Button>
                <Button icon
                  as="a" target="_blank" href={`mailto:${etabState?.mail}`}
                  className="mt-2"
                  color='blue'
                  >
                  <Icon name='mail' />
                </Button>
              </Button.Group>

              {/* add booking */}
            <Grid.Row columns={1}>
              <Grid.Column>
                <Button
                  as="a" target="_blank" href={linkBe} {...bookingEngineLinkProps}
                  className="mt-2"
                  content={globalContext.translations.addBooking}
                  size='medium'
                  color='green'
                  compact
                  icon='cart'
                  labelPosition='left' 
                  fluid />
              </Grid.Column>
            </Grid.Row>

            </Grid>

          </Card.Description>
        </Card.Content>
        
            
      </Card>
    </>
  )
}

export default Establishment;


/*<Card
        className='establishment'
        centered
      >
        <Card.Header style={{height:'200px'}}>
          { showMapState ?
            <Gmap lat={parseFloat(etabState?.latitude)} lng={parseFloat(etabState?.longitude)} zoom={13} establishment={etabState}/>
          : <Image 
              className="imageCard"
              src={etabState?.logo ?? ""} 
              ui={true}
            /> 
          }
          
        </Card.Header>
        <Card.Content>
          {/* Nom Etab }
          <Card.Header textAlign="center">{etabState?.name}</Card.Header>
          <Card.Description textAlign="center">
            <Grid >
              <Grid.Row columns={1}>
                <Grid.Column>
                  {/* Adresse }
                  {etabState?.firstAddress ? etabState?.firstAddress + "," : ""}
                  <br></br>
                  {etabState?.zipCode ? etabState?.zipCode : ""} {etabState?.city ? etabState?.city : ""}
                </Grid.Column>
              </Grid.Row>
            
              {/* Voir la map }
              {
                etabState?.latitude && etabState?.longitude ?
                <Grid.Row columns={1}>
                  <Grid.Column>
                    <Button
                      className="mt-2"
                      onClick={() => toggleShowMap()}
                      content={"voir la carte"}
                      size='mini'
                      compact
                      icon='map marker alternate'
                      labelPosition='left' 
                      fluid />
                  </Grid.Column>
                </Grid.Row>
                : ""
              }
              

              {/* Mailto et CallTo }
              <Grid.Row columns={2}>
                <Grid.Column>
                  <Button
                    as="a" target="_blank" href={`tel:${etabState?.telephone}`}
                    className="mt-2"
                    content={"telephone"}
                    size='mini'
                    color='blue'
                    compact
                    icon='phone'
                    labelPosition='left'
                    fluid />
                </Grid.Column>
                <Grid.Column>
                  <Button
                    as="a" target="_blank" href={`mailto:${etabState?.mail}`}
                    className="mt-2"
                    content={"email"}
                    size='mini'
                    color='blue'
                    compact
                    icon='mail'
                    labelPosition='left'
                    fluid />
                </Grid.Column>
              </Grid.Row>

            </Grid>

          </Card.Description>
        </Card.Content>
        <Card.Content textAlign="right" extra >
          <Grid>
            {/* add booking }
            <Grid.Row columns={1}>
                  <Grid.Column>
                    <Button
                      as="a" target="_blank" href={linkBe}
                      className="mt-2"
                      content={globalContext.translations.addBooking}
                      size='mini'
                      color='green'
                      compact
                      icon='cart'
                      labelPosition='left' 
                      fluid />
                  </Grid.Column>
                </Grid.Row>
          </Grid>
        </Card.Content>
      </Card>*/